import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M12.45 37.65 10.35 35.55 21.9 24 10.35 12.45 12.45 10.35 24 21.9 35.55 10.35 37.65 12.45 26.1 24 37.65 35.55 35.55 37.65 24 26.1Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

import { toRefs } from 'vue'

    
export default /*#__PURE__*/_defineComponent({
  props: {
    size: { default: 12 }
  },
  setup(__props: any) {

const props = __props as { size: number }

    

    const { size } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: _unref(size),
    height: _unref(size),
    viewBox: "0 0 48 48",
    fill: "currentColor",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, _hoisted_3, 8, _hoisted_1))
}
}

})